import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_PRECIOS_PARCELAS: function({ commit }, data){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.precios.parcelas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },

    BACK_PRECIOS_PARCELAS_CREAR: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.precios.parcelas.crear'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },

    BACK_PRECIOS_PARCELAS_VER: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.precios.parcelas.show'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },

    BACK_PRECIOS_PARCELAS_BORRAR: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.precios.parcelas.borrar'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },

    BACK_PRECIOS_PARCELAS_EDITAR: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.precios.parcelas.editar'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_PARCELA_PLAZAS: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.precios.parcela.plazas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_PARCELAS_SYNC: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.precios.parcelas.sync'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PARCELAS_ZONAS: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.parcelas.zonas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PARCELAS_ZONA_BUTACAS: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.parcelas.zona.butacas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PARCELAS_BLOQUEAR_PARCELAS: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.parcelas.bloquear-parcelas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PARCELAS_CARRITO_GUARDAR_DATOS_COMPRADOR: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.parcelas.carrito.guardar-datos-comprador'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PARCELAS_CARRITO_PROCESAR_PEDIDO: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.parcelas.carrito.procesar-pedido'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTADO_PARCELAS_VENDIDAS: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.listado.parcelas.vendidas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PARCELAS_INFORME_EXCEL: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.parcelas.informe.excel'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PARCELAS_INFORME_ESTADISTICAS: function({ commit }, data ){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.parcelas.informe.estadisticas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};